import { Img } from "components";

export default function InNews() {
    return <article className="mx-auto w-full max-w-5xl px-6 py-10 md:py-14">
        <header className="space-y-4">
            <h1 className="text-balance text-5xl font-semibold tracking-tight text-[#0C0C0C] md:text-3xl sm:text-2xl">
                {
                    "SooMuch.AI Launches India’s First AI‑Powered Complete Marketing Platform for Schools — ₹5 Lakh Worth AI Services Free for the First Year. Backed by Microsoft, Meta & Google, and aligned with India’s Bhashini Mission"
                }
            </h1>
        </header>
        <div className="mt-8 flex md:flex-col gap-2 justify-center">
            <div className="flex gap-3 text-sm text-muted-foreground">
                <span className="text-xs">Hyderabad—July 2025</span>
                <span className="flex items-center gap-2">
                    <span className="inline-block h-1.5 w-1.5 rounded-full bg-foreground/60" aria-hidden="true" />
                    <span className="inline-block h-1.5 w-1.5 rounded-full bg-foreground/60" aria-hidden="true" />
                    <span className="inline-block h-1.5 w-1.5 rounded-full bg-foreground/60" aria-hidden="true" />
                    <span className="sr-only">{"Social links"}</span>
                </span>
            </div>
            <section className="flex flex-col gap-4 text-pretty leading-7">
                <Img src={"/images/new-landing-page/aiSoomuchNews.png"} alt="ai soomuch news" />
                <p className="text-muted-foreground">
                    {
                        "SooMuch Smart Solutions Pvt Ltd has officially launched SooMuch.AI — the dedicated marketing partner for schools, an AI‑powered platform built to help schools attract, engage, and retain parents with zero extra cost. As part of its national rollout, SooMuch.AI is offering ₹5 lakhs worth of AI‑powered services completely free for the first year."
                    }
                </p>
                <p className="text-muted-foreground">
                    {
                        "Funded by Microsoft with support from Meta and Google, SooMuch.AI is a patient‑led, multilingual, parent‑first platform inspired by PM Modi’s Bhashini initiative. It is designed to help schools achieve 2× admissions at zero cost while building trust, reducing parent attrition, and unlocking up to ₹2.5 crore in additional revenue."
                    }
                </p>

                <h2 className="pt-3 text-xl font-semibold">SooMuch.AI: AI‑Powered Marketing Partner for Schools</h2>
                <p className="text-muted-foreground">
                    {
                        "SooMuch.AI transforms schools into high‑performing brands with a complete AI‑powered marketing and communication platform."
                    }
                </p>
                <ul className="list-disc pl-6 text-muted-foreground">
                    <li>
                        {
                            "Schools get a responsive, SEO‑rich website that showcases photos, auto‑connects to Google and social media, and collects real‑time parent testimonials."
                        }
                    </li>
                    <li>
                        {
                            "An AI Social Hub that turns 365 days of news, posts, and celebrations into shareable content — driving organic visibility without ad spend."
                        }
                    </li>
                    <li>
                        {
                            "Parent‑student relationships deepen through multilingual WhatsApp and 24×7 Virtual Counsellor that answers queries and books appointments in 10+ languages."
                        }
                    </li>
                    <li>
                        {
                            "Communication gaps disappear with real‑time updates, while admin automations save thousands of hours and deliver actionable parent insights."
                        }
                    </li>
                    <li>
                        {
                            "Outcomes are measurable: ₹5 lakh worth of free AI services in year one, up to ₹2.5 crore in new revenue, and often double admissions within three years."
                        }
                    </li>
                </ul>

                <p className="text-muted-foreground">
                    {
                        "SooMuch.AI is not just software — it is a dedicated AI marketing partner for schools, driving admissions, trust, and long‑term growth. All services are delivered free for one year, with zero setup fees, zero training, and no extra staff required."
                    }
                </p>

                <h3 className="pt-2 text-lg font-semibold">Proven Impact</h3>
                <ul className="list-disc pl-6 text-muted-foreground">
                    <li>{"2× admissions in 3 years"}</li>
                    <li>{"Up to ₹2.5 crore in new annual revenue"}</li>
                    <li>{"Up to 100,000+ parents reached organically"}</li>
                    <li>{"4000+ faculty hours saved every year"}</li>
                </ul>

                <blockquote className="mt-4 border-l-4 border-primary bg-secondary/50 p-4 text-base leading-relaxed">
                    <p className="text-blue-900 font-medium">
                        {
                            "“Schools are the backbone of India’s future. SooMuch.AI acts as their dedicated marketing partner — ensuring growth in admissions, trust and revenue, without adding cost.”"
                        }
                    </p>
                    <footer className="mt-2 text-sm text-muted-foreground">
                        {"— Prapul C. Chandra, Founder of SooMuch Smart Solutions"}
                    </footer>
                </blockquote>

                <h3 className="pt-2 text-lg font-semibold">Building Schools of the Future</h3>
                <p className="text-muted-foreground">
                    {
                        "Designed for inclusivity, SooMuch.AI ensures every parent — across metros or small towns — can access school information in their preferred language. The platform helps schools build trusted brands without extra marketing spend or additional staff, ensuring global‑standard parent experience."
                    }
                </p>
            </section>
        </div>
    </article>
}